module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (style == 'icon') { 
__p+='\n<div class="fmcy-shopping-cart-indicator-icon" title="View your shopping cart">\n  <span class="fmcy-shopping-cart-indicator-count">0</span>\n</div>\n';
 } else { 
__p+='\n<div class="fmcy-shopping-cart-indicator-expanded">\n  <span class="fmcy-shopping-cart-indicator-count">0</span>\n  ';
 if (deliveryMethod === 'pickup') { 
__p+='\n    <span class="fmcy-shopping-cart-indicator-pick-up-location">Items for '+
((__t=( locationName ))==null?'':__t)+
' pick-up</span>\n  ';
 } else if (deliveryMethod === 'local_delivery') { 
__p+='\n    <span class="fmcy-shopping-cart-indicator-pick-up-location">Items for delivery from '+
((__t=( locationName ))==null?'':__t)+
'</span>\n  ';
 } else { 
__p+='\n    <span class="fmcy-shopping-cart-indicator-pick-up-location">Items in your cart at '+
((__t=( locationName ))==null?'':__t)+
'</span>\n  ';
 } 
__p+='\n</div>\n';
 } 
__p+='\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/cart/shopping-cart-indicator/shopping-cart-indicator.html
 ** module id = 446
 ** module chunks = 1 27 28 80 143
 **/